import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from '~/src/App'

// The layout renders these only when SENTRY_BROWSER_DSN is set, so nothing reports from
// a local run. A DSN is public by design; the TrueMath API key never appears here.
const meta = (name: string) =>
  document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content

const dsn = meta('sentry-dsn')

if (dsn) {
  Sentry.init({
    dsn,
    environment: meta('sentry-environment'),
    sendDefaultPii: false,
    tracesSampleRate: 0,
  })
}

const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
